import React, { PropTypes } from "react";
import Bildtext from 'components/Helpers/Bildtext/Bildtext';

const Iframe = ({value, children}) => {
  const size = require('styleTools/SizeClasses.scss');
  const src = (typeof value === 'string' && value) || (value && value.src);
  const sizeClass = (value && value.storlek && size[value.storlek]) || size.l;
  const height = (value && value.height) || "56.25%";
  return (
    <div className={sizeClass}>
      <div className="resizer" style={{position:"relative", paddingTop: height}}>
        <iframe style={{position:"absolute", top:"0", width: "100%", height:"100%"}} src={src} scrolling="no" allowFullScreen="true"></iframe>
      </div>
      {children}
      {typeof value === 'object' &&
        <Bildtext text={value.bildtext} foto={value.foto} credit={value.credit}/>
      }
    </div>
  );
};

export default Iframe;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Iframe/Iframe.js
 **/